import ContentUpload from 'module/ContentUpload/ContentUpload';

import { useEffect } from 'react';

import { Button, Form, Input } from 'antd';
import { useGetArticleContentQuery, useSendSupervisorOpinionMutation } from 'services';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { fetchError } from 'slices/commonSlice';
import { openNotification } from 'utils';
import { useNavigate } from 'react-router-dom';
import { useOfferListReturnURL } from 'hooks';

const { TextArea } = Input;

/**
 *
 * @param {offerID} article offer id
 * @returns
 */
function AfterCopyritghtSupervisorControlForm({ offerID }) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [sendSupervisorOpinionMutation] = useSendSupervisorOpinionMutation();

  const navigate = useNavigate();

  const offerListURL = useOfferListReturnURL();

  const [form] = Form.useForm();
  const { data } = useGetArticleContentQuery({ offerID }, { skip: !offerID });

  const handleFinish = async (values) => {
    delete values.itemFile;
    delete values.idCard;

    const data = {
      opinion: 'approved',
      opinionDescription: values.description,
    };
    const { error } = await sendSupervisorOpinionMutation({ id: offerID, body: data });
    if (error) {
      return dispatch(
        fetchError(
          formatMessage(
            {
              id: 'article.form.fetchError',
            },
            { error: error.status }
          )
        )
      );
    }
    openNotification({
      message: formatMessage({
        id: 'appModule.actionSuccessfully',
      }),
    });
    form.resetFields();
    navigate(offerListURL);
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        itemFile: data.contents.find((item) => item.type === 0),
        idCard: data.contents.find((item) => item.type === 1),
      });
    }
  }, [data, form]);

  return (
    <Form
      form={form}
      onFinish={handleFinish}
      layout="vertical"
    >
      <ContentUpload id={offerID} />
      <Form.Item name="description">
        <TextArea
          placeholder="Notunuz varsa girebilirsiniz"
          rows={8}
          showCount
        />
      </Form.Item>
      <Button
        block
        className="gx-mt-4"
        htmlType="submit"
      >
        {formatMessage({ id: 'article.status.sendItem' })}
      </Button>
    </Form>
  );
}
export default AfterCopyritghtSupervisorControlForm;
